import React, { useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid';
import { Box, Typography } from '@mui/material';
import { useGameStateContext } from '../ContextProviders/GameStateContextProvider';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { ThemeProvider } from '@emotion/react';
import gameConfig from '../gameConfig'
import Fireworks from '@fireworks-js/react';
import { useAnimate, motion, useAnimation, AnimatePresence } from 'framer-motion';

export default function JackpotDisplay({ sound}) {

    let theme = createTheme();
    theme = responsiveFontSizes(theme);

    const gameState = useGameStateContext();
    const [animationState, setAnimationState] = useState('Idle');
    const refFireworks = useRef(null);

    const doFireworks = (on) => {
        if (on)
            refFireworks.current.start();
        else
            refFireworks.current.stop();

        //setAnimationState('Fireworks');
        //setInterval(() => setAnimationState('Idle'), 5000);
        //console.log("Running Jackpot Changed animation");

    }


    return (
        <Box
            component={motion.div}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
                alignItems: 'center',
                /*bgcolor: '#EEEEEE',*/
                height: '56%',
                width: '80%',
                mt: '15%',
                mb: '6%',
            }}
        >
            {
                gameState.jackpots && (<>
                    <ThemeProvider theme={theme}>
                        {
                            Object.keys(gameState.jackpots).map((jp) => (
                                <JackpotDisplayLine key = {"j"+jp} jpName={jp} onJackpotChangeAnimation={doFireworks} />
                            ))
                        }
                        {//animationState !== 'Idle' && 
                            (
                                <Fireworks
                                    ref={refFireworks}
                                    autostart={false}
                                    options={{
                                        intensity: 40,
                                        opacity: 0.3,
                                        sound: {
                                            enabled: `${sound}`,
                                            files: [
                                                'Sounds/explosion0.mp3',
                                                'Sounds/explosion1.mp3',
                                                'Sounds/explosion2.mp3'
                                            ],
                                            volume: {
                                                min: 4,
                                                max: 8
                                            }
                                        },
                                        lineWidth: {
                                            explosion: {
                                                min: 1,
                                                max: 7
                                            },
                                            trace: {
                                                min: 1,
                                                max: 2
                                            }
                                        }
                                    }}
                                    style={{
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        position: 'absolute',
                                    }}
                                />
                            )}
                    </ThemeProvider>
                </>
                )
            }
        </Box>
    )
}

function JackpotDisplayLine({ jpName, onJackpotChangeAnimation }) {
    let theme = createTheme();
    theme = responsiveFontSizes(theme);

    const gameState = useGameStateContext();


    const animation = useAnimation();
    const symbolVariants = {
        fadeOut: { opacity: 0, y: -80 },
        fadeIn: { opacity: 1, y: 0 }
    }
    const textVariants = {
        fadeOut: { scale: [1, 2, 1] }
    }
    const jackpotVariants = {
        fadeOut: {
            transition: {
                staggerChildren: 0.5,
                delayChildren: 0.3,
                duration: 1.0
            },
        },
        fadeIn: {
            transition: {
                staggerChildren: 0.5,
                delayChildren: 0.3,
                duration: 1.0
            },
        },
        text:{}
    }
    const insideVariants = {
        init: {opacity : 0, transition:{ duration: 0 }},
        text: { scale: [1, 2, 1], opacity: [0, 1 , 0],
            transition:{ repeat: 2, repeatDelay: 0.2, duration: 2 }},
    }

    const [symbols, setSymbols] = useState([]);
    const [animationActive, setAnimationActive] = useState(false);

    useEffect(() => {
        const thisJackpot = gameState.jackpots[jpName];
        const runAnimation = async (symbols) => {
            onJackpotChangeAnimation(true);
            await new Promise(r => setTimeout(r, 5000));
            onJackpotChangeAnimation(false);
            await animation.start("fadeOut");
            setSymbols(symbols);
            await animation.start("text");
            await new Promise(r => setTimeout(r, 2000));
            await animation.start("fadeIn");
            setAnimationActive(false);
        }

        if (thisJackpot.changed) {
            setAnimationActive(true);
            runAnimation(thisJackpot.symbols);
            console.log("Running Jackpot Changed animation in " + jpName);
        } else if (!animationActive) {
            setSymbols(thisJackpot.symbols);
        }
    }, [gameState.jackpots]);

    useEffect(() => {
        animation.start("init");
    }, []);
    return (
        <AnimatePresence initial={false}>
            <Box
                component={motion.div}
                initial={false}
                animate={animation}
                key={"Jp " + jpName}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    /*bgcolor: '#EEEEEE',*/
                    m: 1,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    height: '30%',
                }}
            >
                
                <Box
                    component={motion.div}
                    variants={textVariants}
                    transition={{ repeat: 3, repeatDelay: 0.2, duration: 2 }}
                    key={"JpA " + jpName}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        m: 0,
                        width: '100px',
                    }}
                    justifyContent="center"
                    alignItems="center">
                    <Typography variant="h6" sx={{ color: '#FFD700' }}>{jpName.charAt(0).toUpperCase() + jpName.slice(1)}</Typography>
                </Box>
                <Box
                    component={motion.div}
                    variants={jackpotVariants}
                    key={"JpB " + jpName}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        //boxSizing: 'content-box',
                        width: '70%',
                        height: '100%',
                    }}
                    style={{
                        background: gameConfig.colors.jackpots[jpName],
                        borderRadius: "20px"
                    }}>
                    {symbols.map((s, sidx) => (
                        <Box
                            component={motion.div}
                            variants={symbolVariants}
                            key={"JpC " + jpName + " Sym " + sidx}
                            sx={{
                                boxSizing: 'content-box',
                                aspectRatio: 183 / 164,
                                //width: '15%',
                            }}
                            style={{
                                m: 0,
                                padding: 0
                            }}
                        ><img width="90%" src={process.env.PUBLIC_URL + "/Images/" + s + ".png"} />
                        </Box>
                    ))
                    }
                    <Box
                        key={"JpT  " + jpName}
                        component={motion.div}
                        variants={insideVariants}
                        sx={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: 'column'
                        }}>
                        <Typography variant="h4">The jackpot has been cracked!</Typography>
                    </Box>
                </Box>
                <Box
                    component={motion.div}
                    variants={textVariants}
                    transition={{ repeat: 3, repeatDelay: 0.2, duration: 2 }}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        width: '80px',
                        m: 0,
                    }}>
                    <Typography variant="h6" sx={{ color: '#FFD700' }}>{Math.trunc(gameState.jackpots[jpName].money)}$</Typography>
                </Box>
            </Box>
        </AnimatePresence>
    );
}